import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
const TopLevelError = (props)=>{
    return props.errors && props.errors.length ? /*#__PURE__*/ _jsxs("div", {
        className: "toast toast-error",
        children: [
            " ",
            props.errors.join(' '),
            " "
        ]
    }) : /*#__PURE__*/ _jsx("span", {});
};
export default TopLevelError;
